import { render, staticRenderFns } from "./WorkBookTabLine.vue?vue&type=template&id=33a53304&scoped=true&"
import script from "./WorkBookTabLine.vue?vue&type=script&lang=js&"
export * from "./WorkBookTabLine.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookTabLine.vue?vue&type=style&index=0&id=33a53304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a53304",
  null
  
)

export default component.exports